import RealisasiProduksiAsetApi from "./RealisasiProduksiAsetApi";

export default RealisasiProduksiAsetApi;
